import { useEffect, useState } from "react";
import { mediaUrl } from "@/lib/api";

// Loads VTT tracks as same-origin blob URLs so the cross-origin video needs no CORS mode.
export function useSubtitleTracks(subtitles) {
  const [tracks, setTracks] = useState([]);
  useEffect(() => {
    let urls = [];
    let cancelled = false;
    Promise.all(
      (subtitles || []).map(async (s) => {
        const res = await fetch(mediaUrl(s.url));
        const blob = new Blob([await res.text()], { type: "text/vtt" });
        const src = URL.createObjectURL(blob);
        urls.push(src);
        return { ...s, src };
      })
    )
      .then((t) => !cancelled && setTracks(t))
      .catch(() => !cancelled && setTracks([]));
    return () => {
      cancelled = true;
      urls.forEach((u) => URL.revokeObjectURL(u));
    };
  }, [subtitles]);
  return tracks;
}
